import { createContext, useContext } from "react";
export const OfferCalculatorStateContext = createContext(null);
export const OfferCalculatorDispatchContext = createContext(null);
export function useOfferCalculatorState() {
    const ctx = useContext(OfferCalculatorStateContext);
    if (!ctx) {
        throw new Error("useOfferCalculatorState must be used within OfferCalculatorProvider");
    }
    return ctx;
}
export function useOfferCalculatorDispatch() {
    const ctx = useContext(OfferCalculatorDispatchContext);
    if (!ctx) {
        throw new Error("useOfferCalculatorDispatch must be used within OfferCalculatorProvider");
    }
    return ctx;
}
